import { render, staticRenderFns } from "./PackagingTracking.vue?vue&type=template&id=58f8e89b"
import script from "./PackagingTracking.vue?vue&type=script&lang=js"
export * from "./PackagingTracking.vue?vue&type=script&lang=js"
import style0 from "./PackagingTracking.vue?vue&type=style&index=0&id=58f8e89b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports